module.exports = __webpack_public_path__ + "static/img/logo.81978021.png";